import React, { useEffect } from 'react'
import io from 'socket.io-client';
import '../styles/buyins.css'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

function Buyins({ gameID, buyinsList, updatedBuyinsList }) {
    const token = localStorage.getItem('token');
    useEffect(() => {
        if (!gameID) return;
        axios.get(`https://kaskas.pro/poker-stats-server/api/api/getBuyinList/${gameID}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            if (response.data) {
                updatedBuyinsList(response.data)
            }
        })

        const socket = io('https://kaskas.pro', { path: '/socket.io/' }); 
        socket.on('updatedBuyin', (data) => {
            if (!data || !data.buyinArray || data.gameID !== gameID) return;
            updatedBuyinsList(data.buyinArray)
        });
        return () => {
            socket.disconnect();
        };
    }, [gameID])

    function deleteBuyinAndUpdateList(buyinObject) {
        axios.post('https://kaskas.pro/poker-stats-server/api/api/deleteBuyin', { gameID, buyinId: buyinObject.buyinId, playerId: buyinObject.playerId, amount: buyinObject.buyinAmount }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).catch(err => {
            alert(err)
        })
    }


    return (
        <div className='chartContainer'>
            <h2 className='title'>היסטורית פריטות</h2>
            <div className="buyinsList" id="scroller">
                <ul>
                    {buyinsList.map((buyinObject) => (
                        <li className='listItem' key={buyinObject.buyinId}>
                            <div className='liContent'><span className='bold'>{buyinObject.time}: </span><strong>{buyinObject.playerName}</strong> פרט {buyinObject.buyinAmount} סך הכל <span className='bold'>({buyinObject.totalBuyinAmount})</span></div>
                            <FontAwesomeIcon icon={faXmark} onClick={() => deleteBuyinAndUpdateList(buyinObject)} className='deleteBuyinIcon' />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Buyins